import { Route, RouteProps, Switch } from 'react-router-dom';

import { useEvent } from './Common/EventProvider';
import BuyRegistrationPage from './Resale/BuyRegistrationPage';
import CheckoutPage from './Checkout/CheckoutPage';
import CheckoutProvider from './Checkout/CheckoutProvider';
import CheckoutSummaryProvider from './Checkout/CheckoutSummaryProvider';
import ErrorBoundary from './Checkout/ErrorBoundary';
import EventNotFound from '../common/EventNotFound';
import InterestPage from './Checkout/InterestPage';
import NetworkError from '../common/NetworkError';
import OverviewPage from './Resale/OverviewPage';
import SuccessPage from './Checkout/Success/SuccessPage';
import UI from '../common/UI';
import WaitlistPage from './Checkout/WaitlistPage';
import WidgetContainer from './Common/WidgetContainer';

const Main = () => {
  const { event, error } = useEvent();

  if ((error?.graphQLErrors?.[0]?.extensions?.validation as any)?.event?.exists) {
    return <EventNotFound />;
  }

  if (error) {
    return <NetworkError />;
  }

  return (
    <ErrorBoundary redirect={event?.checkout_url}>
      <WidgetContainer showRegisterButton={!!event}>
        <Switch>
          <EventRoute
            path="/:eventId/waitlist/:ticketId"
            render={({ match: { params: { ticketId } } }) => (
              <WaitlistPage ticketId={ticketId} />
            )}
          />
          <EventRoute path="/:eventId/interest">
            <InterestPage />
          </EventRoute>
          <EventRoute path="/:eventId/thank-you">
            <SuccessPage />
          </EventRoute>
          <EventRoute
            path="/:eventId/resale/:registrationId/:resaleToken"
            render={({ match: { params: { registrationId, resaleToken } } }) => (
              <BuyRegistrationPage
                registrationId={registrationId}
                resaleToken={resaleToken}
              />
            )}
          />
          <EventRoute path="/:eventId/resale">
            <OverviewPage />
          </EventRoute>
          <Route
            path="/:eventId/:step?"
            render={({ match: { params: { step } } }) => (
              <CheckoutSummaryProvider>
                <CheckoutProvider
                  step={step as any}
                  render={(props) => (
                    <CheckoutPage {...props} />
                  )}
                />
              </CheckoutSummaryProvider>
            )}
          />
        </Switch>
      </WidgetContainer>
    </ErrorBoundary>
  );
};

/**
 * Displays a loader if the event has not finished loading yet.
 */
const EventRoute = ({ render, children, ...props }: RouteProps) => {
  const { event } = useEvent();

  return (
    <Route {...props} render={event ? render : undefined}>
      {event ? children : <UI.PageLoader />}
    </Route>
  );
};

export default Main;
